module.exports = __webpack_public_path__ + "img/239.58f958d6.jpg";